var exports = {
  "hs": "xfd349460--2e1617--authenticate_motivation",
  "Zc": "xfd349460--2e1617--authenticate_motivation-icon",
  "E0": "xfd349460--2e1617--authenticate_motivation-title",
  "Bv": "xfd349460--2e1617--authenticate_motivation-text",
  "In": "xfd349460--2e1617--authenticate_motivation-button",
};

module.exports = exports;
